/**
 * This is for testing purposes
 * During integration this file should be removed and store should be created where it is now.
 * Reducers should be imported like import reducers from '/{path}/{to}/{redux}/reducers'
 * And be placed in 'newdashboard' branch within root of state
 */
import thunk from 'redux-thunk';

import reducers from './reducers';
import { combineReducers } from 'redux';

export default $ngReduxProvider => {
    'ngInject';
    const rootReducer = combineReducers({
        newdashboard: reducers
    });
    $ngReduxProvider.createStoreWith(rootReducer, [ thunk ]);
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/redux.config.js